module.exports = __webpack_public_path__ + "img/Group 482.324ec2c4.svg";